import { css } from "lit";

export const groupButtonStyles = css`
  :host {
    display: inline-block;
  }

  .group-container {
    background: var(--sds-color-background-default-tertiary);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    padding: var(--sds-size-space-150);

    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    gap: var(--sds-size-space-200);
  }
`;
